// extracted by mini-css-extract-plugin
export var basicSectionContainer = "basicSection-module--basicSectionContainer--bf798";
export var basicSectionMainContainer = "basicSection-module--basicSectionMainContainer--05ea3";
export var body = "basicSection-module--body--0d9d0";
export var button = "basicSection-module--button--97bef";
export var contactSubheader = "basicSection-module--contactSubheader--3a140";
export var containSection = "basicSection-module--containSection--558fc";
export var divider = "basicSection-module--divider--d40ee";
export var dividerContainer = "basicSection-module--dividerContainer--082d9";
export var externalLink = "basicSection-module--externalLink--e2007";
export var formWrapper = "basicSection-module--formWrapper--f715c";
export var group = "basicSection-module--group--65d7c";
export var heroGridColumn = "basicSection-module--heroGridColumn--7afe8";
export var hideDueToWallImage = "basicSection-module--hideDueToWallImage--8a95c";
export var internalLink = "basicSection-module--internalLink--4f143";
export var list = "basicSection-module--list--b5f7f";
export var listItem = "basicSection-module--listItem--d07b1";
export var listItemLabel = "basicSection-module--listItemLabel--4346b";
export var portal = "basicSection-module--portal--f7a04";
export var rightBackgroundIcon = "basicSection-module--rightBackgroundIcon--e5268";
export var secondaryBtn = "basicSection-module--secondaryBtn--79f67";
export var textGridColumn = "basicSection-module--textGridColumn--ceee4";
export var theAllInOneAccessSolutionForRetailAndSpecialtyLiteSuccess = "basicSection-module--the-all-in-one-access-solution-for-retail-and-specialty-lite-success--b1328";
export var title = "basicSection-module--title--c0097";
export var wallImage = "basicSection-module--wallImage--268a7";